import { Card, Header, Icon, Segment, Tooltip } from '@mairistem/composants';

import AccueilTileIcon from '@/components/Accueil/AccueilTileIcon';
import type { ElementDisponibleType } from '@/types';

type ElementsDisponiblesProps = {
  elements: ElementDisponibleType[];
  onInsererElement: (valeur: string) => void;
};

const ElementsDisponibles = (props: ElementsDisponiblesProps) => {
  const { elements, onInsererElement } = props;

  return (
    <Segment basic style={{ padding: 0 }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: '1em',
          height: 30,
        }}
      >
        <Header as="h4" style={{ margin: 0 }}>
          Éléments disponibles
        </Header>
        <Tooltip
          mouseEnterDelay={100}
          // @ts-expect-error
          flowing
          type="warning"
          trigger={<Icon name="Info" iconSet="Lucide" link size={20} style={{ marginLeft: 10 }} />}
          message={
            <div>
              <Header as="h5">Astuce :</Header>
              <div style={{ maxWidth: 300 }}>
                Cliquez sur un élément pour l&apos;insérer à la position du curseur dans votre
                texte.
              </div>
            </div>
          }
          position="bottom right"
        />
      </div>
      <div style={{ height: 450, overflowY: 'auto', padding: '0.3em 0.25em 0.3em 0.25em' }}>
        {elements.map((element) => (
          <Card
            key={element.valeur}
            data-testid={`element-${element.valeur}`}
            onClick={() => onInsererElement(element.valeur)}
            fluid
          >
            <Card.Content>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '0.5em',
                }}
              >
                <AccueilTileIcon
                  name={element.icon as any}
                  iconSet="Lucide"
                  size={25}
                  style={{ marginRight: '1em' }}
                />
                <Header as="h5" floated="left">
                  {element.libelle}
                </Header>
              </div>
              <Header as="h6" block textAlign="center" style={{ margin: 0 }}>
                {element.valeur}
              </Header>
            </Card.Content>
          </Card>
        ))}
      </div>
    </Segment>
  );
};

export default ElementsDisponibles;
